export default __webpack_public_path__ + "static/media/doc.5ac516b8.svg";